
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');

// Utilisez createRoot à la place de ReactDOM.render
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);
